'use es6';

import { List, Record } from 'immutable';
import InternalList from './List';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  lists: List(),
  listsForContent: List(),
  listsForContentStatus: RequestStatus.UNINITIALIZED,
  listsStatus: RequestStatus.UNINITIALIZED,
  staticLists: List(),
  staticListsStatus: RequestStatus.UNINITIALIZED
};
export default class Lists extends Record(DEFAULTS) {
  static fromListsJS(data) {
    return new Lists({
      lists: List(data.lists).map(InternalList.fromJS),
      listsStatus: RequestStatus.SUCCEEDED
    });
  }

  static fromStaticListsJS(data) {
    return new Lists({
      staticLists: List(data.lists).map(InternalList.fromJS),
      staticListsStatus: RequestStatus.SUCCEEDED
    });
  }

  static fromSpecificListsJS(data) {
    return new Lists({
      listsForContent: List(data.lists).map(InternalList.fromBatchJS),
      listsForContentStatus: RequestStatus.SUCCEEDED
    });
  }

}